import React from "react";
import './betaVersion.css';
export const BetaVersion=()=><span className="beta-version">(βeta)</span>;